@include host-component-properties;

:host {
  --paf-timetable-leg-descent-override: -6;
}

section {
  position: relative;
}

.timetable-leg {
  @include level2-grid;

  min-height: px-to-rem(100);
  line-height: 1.5;
}

.timetable-leg__times {
  display: flex;
  flex-direction: column;
}

::slotted([slot="departure-time"]) {
  flex-grow: 1;
}

::slotted([slot="arrival-time"]) {
  justify-self: flex-end;
  margin-block-end: px-to-rem(var(--paf-timetable-leg-descent-override));
}

.timetable-leg__pearl_chain {
  display: flex;
  justify-content: center;
}

.timetable-leg__details_arrival,
.timetable-leg__details_departure {
  display: flex;
  flex-direction: column;
  row-gap: px-to-rem(var(--paf-global-spacing-fixed-2x));
}

.timetable-leg__details_departure {
  flex: 1 1 auto;
  margin-block-start: px-to-rem(-5);
}

.timetable-leg__attributes_and_utilization {
  display: flex;
  flex-wrap: wrap;
  row-gap: px-to-rem(var(--paf-global-spacing-fixed-4x));
  margin: 0;
  margin-block-start: px-to-rem(var(--paf-global-spacing-fixed-1x));
  margin-block-end: px-to-rem(var(--paf-global-spacing-fixed-3x));

  @include mq($from: small) {
    align-items: center;
    column-gap: 0;
    margin-block-start: px-to-rem(var(--paf-global-spacing-fixed-2x));
  }
}

.timetable-leg__details {
  display: flex;
  flex-direction: column;
}

.timetable-leg__details_arrival {
  justify-self: flex-end;
  margin-block-start: px-to-rem(var(--paf-global-spacing-fixed-13x));
  margin-block-end: px-to-rem(var(--paf-timetable-leg-descent-override));
}

.timetable-leg__platform {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;

  @include mq($from: small) {
    flex-grow: 0;
    align-self: flex-end;
  }
}

.timetable-leg-a11y {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
}

::slotted([slot]:empty) {
  display: none;
}

::slotted([slot="pearl-chain"]) {
  display: flex;
}
